export default "__VITE_ASSET__e7984c3f__"